import { render } from "./NIRFDocumentsView.vue?vue&type=template&id=e1d823ca"
import script from "./NIRFDocumentsView.vue?vue&type=script&lang=js"
export * from "./NIRFDocumentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__